import { Chip, Divider, Grid, useMediaQuery } from '@mui/material'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import "../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import GlobalPageHeaderText from '../utility/globalPageHeaderText';
import globalStyles from "../../assets/styles/global.module.scss";
import dividerStyle from '../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import styles from "../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import agent from '../../services/api';
import { UserContext, UserContextPayload } from '../../context/userContext';
import IconsColor from '../utility/iconsColor';
import TemplateCard from '../global/templateCard';
import GlobalButton from '../utility/globalButton/button';
import { IntegrationContext, IntegrationContextPayload } from '../../context/integrationContext';
import { useNavigate } from 'react-router-dom';
import { deleteMetaIntegrationPayload, globalIntegrationType, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../models/axiosModel';
import { GlobalTable } from '../utility/globalTable';
import deleteDoc from "../../assets/deleteDoc.svg";
import { formatDateTime, getBusinessUsername, getChannelIcon, getLinkedChatbotNumbers, hasAIChatbotManageAccess, hasChannelsManageAccess, isWhatsAppBusinessApp } from '../../utils/constants';
import { primaryColor } from '../../utils/colors';
import linkedDetailsIcon from '../../assets/chatbotAssets/linkedDetails.svg'
import GlobalDeletePopup from '../utility/globalDeletePopup/globalDeletePopup';
import whatsappIcon from '../../assets/Whatsapp.svg'
import instagramIcon from '../../assets/images/channels/instagram/instagram.png'
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface chatsProps {
    mainSection?: boolean
}
interface integrationRowData {
    id: number | string,
    iconSrc: string,
    channel_icon: ReactElement,
    channel_name: string | ReactElement,
    channel_name_label?: string,
    channel_linked_details: ReactElement,
    channel_last_updated_timestamp: string,
    channel_feature: string,
    channel_id?: number | string,
}

interface integrationItem {
    name: string,
    image: ReactElement,
    description: string,
    actionItem: ReactElement,
}



export default function Integration(props: chatsProps) {
    const navigate = useNavigate()
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const innerHeight = window.innerHeight - 110;
    const { setFlagLoading, userDetail, handleError, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const [flagDeleteIntegrationDataPopup, setFlagDeleteIntegrationDataPopup] = useState<boolean>(false);
    const [integrationSelected, setIntegrationSelected] = useState<null | integrationRowData>(null)
    const [integrationViewData, setIntegrationViewData] = useState<integrationRowData[] | []>([]);
    const { getGlobalIntegrationTypeList, globalIntegrationTypeList, getIntegrationList, integrationList, integrationListNewStructure, slackIntegrations, setSlackIntegrations, zohoIntegrations, setZohoIntegrations, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload

    let headerList = [
        {
            name: "",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_icon",
            iconKey: "channelIcon",
            sx: { width: "20px !important", paddingRight: "0px !important" }
        },
        {
            name: "Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_name",
        },
        {
            name: "Linked Details",
            alignment: "left",
            flagIcon: true,
            valueKey: "channel_linked_details",
        },
        {
            name: "Last Modified (UTC)",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_last_updated_timestamp",
        },
        ...(hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            {
                name: "",
                alignment: "right",
                flagIcon: true,
                valueKey: "",
                iconKey: "editIcon"
            }
        ] : []),
        {
            name: "feature",
            alignment: "right",
            flagIcon: true,
            valueKey: "channel_feature",
            iconKey: "editIcon",
            hidden: true
        },
    ]

    const [adjustedHeaderList, setAdjustedHeaderList] = useState(headerList);

    useEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            await getGlobalIntegrationTypeList();
            let res;
            if(hasAIChatbotManageAccess(apiRoutesPermissionAssignment, userDetail)){
                res = await getIntegrationList();
            } else {
                res = await getMetaIntegrationList();
            }
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, [])

    const deleteMetaIntegration = async (deleteIntegrationDetails: integrationRowData | null) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let response: any
        if (integrationSelected && deleteIntegrationDetails) {
            if (integrationSelected.channel_feature.toLowerCase() == "slack") {
                response = await agent.deleteSlackIntegration.delete(Number(deleteIntegrationDetails.id))
            }
            else if (integrationSelected.channel_feature == "zoho") {
                if (zohoIntegrations) {
                    const zoho_integration_organization_id = zohoIntegrations?.[0]?.zoho_integration_organization_data?.[0]?.zoho_integration_organization_id;
                    response = await agent.deleteZohoIntegration.delete(String(deleteIntegrationDetails.id), zoho_integration_organization_id);
                }
            }
            else {
                let payload: deleteMetaIntegrationPayload = {
                    channel_id: deleteIntegrationDetails.channel_id ? Number(deleteIntegrationDetails.channel_id) : 0,
                    integrated_channel_id: Number(deleteIntegrationDetails.id)
                }
                if (integrationSelected.channel_feature.toLowerCase() == 'whatsapp') {
                    payload.meta_integration_whatsapp_id = Number(deleteIntegrationDetails.id)
                    delete payload.integrated_channel_id
                }
                response = await agent.deleteMetaIntegration.delete(payload)
            }
            if (response && response.status) {
                let temp = [...integrationViewData]
                temp = temp.filter((integration: integrationRowData) => integration.id != deleteIntegrationDetails.id)
                setIntegrationViewData(temp)
                showSuccess("Integration Deleted Successfully!")
                navigate('/channels')
            } else {
                handleError(response);
            }
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }


    useEffect(() => {
        if (integrationListNewStructure !== null) {
            let updatedData = integrationListNewStructure.flatMap((integrationData: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew, index: number) => {
                let channel_name = integrationData?.channel_name ? integrationData.channel_name : "whatsapp"
                const businessUsername = getBusinessUsername(integrationData, integrationData.channel_name)
                const isWaBusinessApp = isWhatsAppBusinessApp(integrationData)
                const chipLabel = isWaBusinessApp ? "WhatsApp Business App" : "WhatsApp Business Account"; 
                return {
                    id: integrationData.integrated_channel_id as number,
                    iconSrc: linkedDetailsIcon,
                    channel_feature: integrationData.channel_name,
                    channel_icon: <Grid item sx={{ display: "flex" }}>{getChannelIcon(channel_name)}</Grid>,
                    channel_name_label: channel_name?.toLowerCase() === "whatsapp" ? `${businessUsername}(${chipLabel})` : businessUsername,
                    channel_name: channel_name?.toLowerCase() === "whatsapp" ? (
                        <Grid container alignItems="center" columnGap={1} flexWrap="nowrap">
                            <Grid item>{businessUsername}</Grid>
                            <Grid item className={`${styles.whatsAppBusinessAppLabel}`}>
                                <Chip label={chipLabel} size="small" />
                            </Grid>
                        </Grid>
                    ) : businessUsername,
                    channel_id: globalIntegrationTypeList?.find((channel: globalIntegrationType) => channel?.channel_name.toLowerCase() == integrationData.channel_name.toLowerCase())?.channel_id || "",
                    channel_linked_details: <span style={{ color: primaryColor }}>{getLinkedChatbotNumbers(integrationData, channel_name)}</span>,
                    channel_last_updated_timestamp: formatDateTime(integrationData.created_at_timestamp, "dmyTime"),
                };
            });
            let slackIntegrationsTemp = slackIntegrations?.map((slackIntegration) => {
                return {
                    id: slackIntegration.slack_integration_id,
                    iconSrc: linkedDetailsIcon,
                    channel_feature: "slack",
                    channel_name: `${slackIntegration.slack_user_real_name} - ${slackIntegration.slack_team_name}`,
                    channel_icon: <IconsColor iconName="colouredSlackIcon" height="20" width="20" />,
                    channel_linked_details: <span style={{ color: primaryColor }}>{`${slackIntegration.slack_channels.filter((channel) => channel.chatbot_slack_assignment_data.length > 0).length} / ${slackIntegration.slack_channels.length}`}</span>,
                    channel_last_updated_timestamp: ""
                }
            }) ?? []
            let zohoIntegrationsTemp = zohoIntegrations?.map((zohoIntegration) => {
                return {
                    id: zohoIntegration.zoho_integration_id,
                    iconSrc: linkedDetailsIcon,
                    channel_feature: "zoho",
                    channel_name: `${zohoIntegration.zoho_user_name} - ${zohoIntegration.zoho_user_email}`,
                    channel_icon: <IconsColor iconName="zoho" height="20" width="20" />,
                    channel_linked_details: <span style={{ color: primaryColor }}>{zohoIntegration.zoho_integration_organization_data[0].zoho_integration_organization_chatbot_data.length}</span>,
                    channel_last_updated_timestamp: formatDateTime(zohoIntegration.timestamp, "dmyTime"),
                }
            }) ?? []
            setIntegrationViewData([...updatedData, ...slackIntegrationsTemp, ...zohoIntegrationsTemp])
        }
    }, [integrationListNewStructure, slackIntegrations, zohoIntegrations])

    const rowClicked = async (e: any, rowDetail: integrationRowData) => {
        if (e.iconKey !== "editIcon") {
            navigate(`/channels/viewintegration/${rowDetail.channel_feature}?id=${rowDetail.id}`)
        }
    }

    const deleteIntegrationDataPopupOpen = (data: null | integrationRowData) => {
        setFlagDeleteIntegrationDataPopup(true)
        setIntegrationSelected(data)
    }
    const menuItems = [
        { label: 'Delete', icon: <img src={deleteDoc} alt="delete" width={"16"} height={"16"} />, action: (e: any) => deleteIntegrationDataPopupOpen(e) },
    ];

    const pollForCallbackStatus = async (stateValue: string, integrationName: string) => {
        const pollInterval = 10000;
        const maxPollingTime = 100000;
        let elapsedTime = 0;

        const intervalId = setInterval(async () => {
            try {
                const response = await agent.getCallbackStatus.get(stateValue);

                if (response.status) {
                    const integrationStatus = response?.data?.integration_status?.toLowerCase();

                    if (integrationStatus === 'completed' || integrationStatus === 'failed') {
                        clearInterval(intervalId);

                        if (integrationStatus === 'failed') {
                            showError(response?.data?.reason)
                        } else {
                            if (integrationName.toLowerCase() == "slack") {
                                const response1 = await agent.getSlackintegrations.get();
                                if (response1.status) {
                                    if (slackIntegrations) {
                                        setSlackIntegrations(response1.data)
                                    }
                                } else {
                                    handleError(response1);
                                }
                                navigate(`viewIntegration/slack?id=${response?.data.integration_details.slack.id}`)
                            } else {
                                const response1 = await agent.getZohoIntegration.get();
                                if (response1.status) {
                                    if (slackIntegrations) {
                                        setZohoIntegrations(response1.data)
                                    }
                                } else {
                                    handleError(response1);
                                }
                            }
                        }
                    } else {
                        console.log("Callback not completed, retrying...");
                    }

                    elapsedTime += pollInterval;

                    if (elapsedTime >= maxPollingTime) {
                        console.log("Polling stopped after 1 minute.");
                        clearInterval(intervalId);
                    }
                } else {
                    handleError(response);
                }
            } catch (error) {
                console.error("Error polling for callback status:", error);
                clearInterval(intervalId);
            } finally {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
            }
        }, pollInterval);
    };
    async function handleIntegration(integrationName: string) {
        try {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            let slackIntegration = globalIntegrationTypeList.find((integration: globalIntegrationType) => integration.integration_app_name?.toLowerCase() == integrationName)
            let currentUrl = window.location.href;
            if (slackIntegration && slackIntegration.integration_app_id) {
                const payload = {
                    current_url: currentUrl,
                    integration_app_id: slackIntegration.integration_app_id,
                };

                const response = await agent.calendlyAuthUrlApi.post(payload);
                if (response.status) {
                    const authUrl = response?.data?.auth_url;
                    if (authUrl) {
                        window.open(response.data.auth_url, "_blank")
                        const stateValue = new URL(authUrl).searchParams.get('state');
                        if (stateValue) {
                            pollForCallbackStatus(stateValue, integrationName);
                        } else {
                            console.error('State param not found in the auth_url.');
                        }
                    }
                } else {
                    handleError(response);
                }
            }
        } catch (error) {
            console.error(error)
        }
    }
    const getIntegrationObj = (integrationType: globalIntegrationType): integrationItem | null => {
        let integrationTypeName = integrationType.channel_name ? integrationType.channel_name.toLowerCase() : integrationType?.integration_app_name ? integrationType?.integration_app_name.toLowerCase() : ""
        switch (integrationTypeName) {
            case "whatsapp":
                return {
                    name: "WhatsApp Business",
                    image: <img alt="whatsApp" src={whatsappIcon} height={"27"} width={"27"} />,
                    description: "Effectively communicate with customers using WhatsApp integration.",
                    actionItem: <GlobalButton buttonText={"Integrate"} onClick={() => navigate('/channels/viewintegration/whatsapp')} className="channelsThemeBtnStyle" />
                }
            case "facebook":
                return {
                    name: "Facebook Messenger",
                    image: <IconsColor iconName="facebook_messenger" width="25px" height="25px" />,
                    description: "Boost your audience's reach and improve engagement through Facebook integration.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { navigate('/channels/viewintegration/facebook') }} />
                }
            case "instagram":
                return {
                    name: "Instagram",
                    // image: <IconsColor iconName="instagram" width="25px" height="25px" />,
                    image: <img alt="instagram" src={instagramIcon} height={"27"} width={"27"} />,
                    description: "Boost your audience's reach and improve engagement through Instagram integration.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { navigate('/channels/viewintegration/instagram') }} />
                }
            case "slack":
                return {
                    name: "Slack",
                    image: <IconsColor iconName="colouredSlackIcon" width="25px" height="25px" />,
                    description: "Connect Slack to receive instant updates and engage with users directly from your workspace.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" disabled={!hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail)} onClick={() => { handleIntegration(integrationTypeName) }} />
                }
            case "zoho desk":
                return {
                    name: "Zoho Desk",
                    image: <IconsColor iconName="zoho" width="25px" height="25px" />,
                    description: "Enable your customer support team to retrieve information from Zoho CRM.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" disabled={!hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail)} onClick={() => { handleIntegration(integrationTypeName) }} />
                }
            default:
                return null
        }
    }

    return (
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
            <Grid container sx={{ padding: props.mainSection ? { xs: "18px 0px", sm: "23px 0px" } : "0px 0px 0px 30px" }}>
                <Grid item xs={12} sm={12}>
                    <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                        {props.mainSection && <><Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`} sx={{ marginBottom: !smallScreen ? "10px" : "" }}>
                            <GlobalPageHeaderText
                                mainHeadText={"Channels"}
                                flagMainTextOnly
                            // mainSubText={"Create Integrations to grow your business"}
                            />
                            {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${styles.dividerStyle} ${dividerStyle.customAPIPageDividerWebhook}`} />}
                        </Grid>
                        </>}
                        <Grid item className={`${globalStyles.fullwidth} ${styles.lowerBlock}`} sx={{ maxHeight: `${innerHeight}px !important`, overflowY: "auto" }}>
                            <Grid container direction={"column"}>
                                {/* upper block */}
                                <Grid item className={styles.upperBlock}>
                                    <Grid container direction={"column"}>
                                        <Grid item className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>Available Channels</Grid>
                                        <Grid item>
                                            <Grid container>
                                                {globalIntegrationTypeList.map((integrationType: globalIntegrationType, ind: number) => {
                                                    let integration: integrationItem | null = getIntegrationObj(integrationType)
                                                    return integration ?
                                                        <TemplateCard
                                                            key={ind}
                                                            cardName={integration.name}
                                                            cardDescription={integration.description}
                                                            cardImage={integration.image}
                                                            // cardOnClick={() => { }}
                                                            cardActionItem={integration.actionItem}
                                                        />
                                                        :
                                                        <></>
                                                })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* lower block */}
                                {
                                    <Grid item xs={12} sx={{ padding: { xs: "10px 20px", lg: "0px 25px 0px 25px" }, width: "100%", overflow: "scroll", boxSizing: "border-box" }}>
                                        <Grid container direction={"column"} className={styles.integrationTable}>
                                            <Grid item xs={12} className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>Integrated Channels</Grid>
                                            <Grid item xs={12}>
                                                <GlobalTable
                                                    headerList={adjustedHeaderList}
                                                    rowData={integrationViewData}
                                                    tableHeight={"42vh"}
                                                    tableContainerHeight={"auto"}
                                                    tableContainerMinHeight={"auto"}
                                                    onCellClick={(e: any, rowDetail: integrationRowData) => { rowClicked(e, rowDetail) }}
                                                    onRowClick={(e: any) => { console.log(e) }}
                                                    deleteRowData={deleteIntegrationDataPopupOpen}
                                                    flagPagination
                                                    menuItemsFromParent={menuItems}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {flagDeleteIntegrationDataPopup &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${integrationSelected?.channel_name_label ?? integrationSelected?.channel_name} channel`}
                    open={flagDeleteIntegrationDataPopup}
                    onClose={() => { setFlagDeleteIntegrationDataPopup(false) }}
                    onDelete={() => {
                        deleteMetaIntegration(integrationSelected)
                        setFlagDeleteIntegrationDataPopup(false)
                    }}
                />
            }
        </Grid >

    )
}
